import {z} from 'zod'
import {Workday} from './Workday.js'

export const Workdays = z.object({
  0: Workday.nullish(),
  1: Workday.nullish(),
  2: Workday.nullish(),
  3: Workday.nullish(),
  4: Workday.nullish(),
  5: Workday.nullish(),
  6: Workday.nullish(),
})
export type Workdays = z.infer<typeof Workdays>
